package de.oevbs.kunde.kundenportal2.services.consent

import de.oevbs.businesspartner.consent2.components.editConsent
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import kotlinx.coroutines.Job

fun RenderContext.consentPage(page: Page) {
    val consentStore = ConsentStore(Job())
    consentStore.loadCustomerModel("")

    headerImageLayout {
        title(page.linkTitle)
        content {
            consentStore.progress.render { step ->
                when (step) {
                    GeneralProgressStep.SUBMIT1 -> renderConsent(consentStore)
                    GeneralProgressStep.SUCCESS2 -> messagePagePre(
                        header = "Erfolgreich gespeichert.",
                        preContent = PortalContactNotes.ConsentWasUpdated().note
                    )
                }
            }
        }
    }
}

fun RenderContext.renderConsent(consentStore: ConsentStore) {

    contentContainer {
        consentStore.initFailedFlow.render { failed ->
            if (failed || PortalSession.current == null) {
                return@render
            }

            paragraph {
                +"Im Anschluss an die Bearbeitung der Einwilligungserklärung erhalten Sie eine Mail, die Ihre aktuellen"
                +" Kommunikations-Einstellungen zusammenfasst. Darin wird auch Ihr bevorzugter Versandweg angezeigt, den Sie "
                textualButton("im Bereich Mein Postfach anpassen können") handledBy { Pages.inboxDelivery.visit() }
                +". Bitte beachten Sie, dass es bis zu 10 Minuten dauern kann, bis Ihre Änderungen übernommen werden und"
                +" Sie die Mail erhalten."
            }

            card {
                editConsent(consentStore) {
                    displaySaveButton = false
                }
            }

            buttonContainer {
                btn {
                    label("Auswahl speichern")
                    busy(globalSubmitTracker.data)
                }.clicks handledBy consentStore.updateConsent
            }
        }
    }
}